const Classes = {
  INIT: 'history_init',
  BODY: 'history__body',
  ITEM: 'history__item',
};

const Selectors = {
  SEARCH_LINK: '[data-action="search"]',
  ITEM: '[data-target="item"]',
  REMOVE: '[data-action="remove"]',
  CLEAR: '[data-action="clear"]',
};

const Events = {
  INIT: 'init.history.cookies',
  UPDATE_COOKIES: 'cookies.update',
  SEND_VALUE_TO_SEARCH: 'send.value.from.history',
  CLOSE_DROPDOWN: 'close.dropdown.event',
};

class History {
  constructor(elem) {
    this.block = elem;
    this.body = this.block.getElementsByClassName(Classes.BODY).item(0);
    this.cookieName = this.block.dataset.cookie;
    this.isFirstInit = true;
    this.maxCookies = this.block.dataset.max;
    this.historyListName = this.block.dataset.name || 'HISTORY_LIST';
    this.historyList = [];

    this.blockClickHandler = this.blockClickHandler.bind(this);
    this.showHistoryList = this.showHistoryList.bind(this);
    this.init();
  }

  searchListener() {
    document.addEventListener(Events.INIT, this.showHistoryList);
  }

  showHistoryList() {
    this.insertHistoryList();
    this.setArrayHtmlItems();
  }

  setArrayHtmlItems() {
    this.items = [...this.block.getElementsByClassName(Classes.ITEM)];
  }

  initHistoryList() {
    const oldHistoryList = JSON.parse(localStorage.getItem(this.historyListName) || '[]');
    if (!oldHistoryList.length) {
      return;
    }
    this.historyList = oldHistoryList.filter((item) => {
      return item.expired < new Date().getTime() + 2629800000;
    });
  }

  hideHistoryList() {
    document.dispatchEvent(new Event(Events.CLOSE_DROPDOWN));
    this.block.classList.remove(Classes.INIT);
  }

  init() {
    this.initHistoryList();
    this.searchListener();
    this.showHistoryList();
    this.block.addEventListener('click', this.blockClickHandler);
  }

  insertHistoryList() {
    this.historyList.reverse();
    window.getBH((bh) => {
      this.body.innerHTML = bh.apply([
        this.historyList.map((item) => [
          {mix: {block: 'history', elem: 'item'},
            attrs: {'data-target': 'item', 'data-item': item.text},
            content: [
              {mix: {block: 'history', elem: 'link'}, tag: 'a', attrs: {'href': '#', 'data-action': 'search'}, content: [
                  {block: 'fi', cls: 'mr-12 font-size-x-large align-middle', mods: {icon: 'clock'}},
                  item.text,
                ]},
              {mix: {block: 'history', elem: 'clear'}, tag: 'a', attrs: {'href': '#', 'data-action': 'remove'}, content: [
                  {block: 'fi', mods: {icon: 'times'}},
                ]},
            ]},
        ]),
      ]);
    });
    this.historyList.reverse();
  }

  blockClickHandler(event) {
    if (!event.target) return;
    const target = event.target;
    const dataAttribute = event.target.dataset.action;

    if (dataAttribute === 'clear') {
      event.preventDefault();
      this.historyList = [];
      this.throwUpdateCookiesEvent();
      this.removeAllHtmlItems();
      this.hideHistoryList();
    }
    if (dataAttribute === 'search') {
      event.preventDefault();
      this.sendFormWithValue(target.closest(Selectors.ITEM));
    }
    if (dataAttribute === 'remove') {
      event.preventDefault();
      this.removeItem(target.closest(Selectors.ITEM));
      this.throwUpdateCookiesEvent();
      if (!this.body.querySelector(Selectors.ITEM)) this.hideHistoryList();
    }
  }

  sendFormWithValue(target) {
    const customEvent = new CustomEvent(Events.SEND_VALUE_TO_SEARCH, {
      detail: target.dataset.item,
    });
    document.dispatchEvent(customEvent);
  }

  throwUpdateCookiesEvent() {
    const customEvent = new CustomEvent(Events.UPDATE_COOKIES, {
      detail: this.historyList,
    });
    document.dispatchEvent(customEvent);
  }

  removeAllHtmlItems() {
    this.items.forEach((item) => {
      item.remove();
    });
  }

  removeItem(item) {
    this.historyList = this.historyList.filter((historyItem) => historyItem.text !== item.dataset.item);
    item.remove();
  }
}

[...document.getElementsByClassName('history')].forEach((elem) => new History(elem));
